import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

export const useCurrentTabId = () => {
  const { tabId: pathTabId } = useParams();
  const { state } = useLocation();
  const tabId = useMemo(() => {
    if (pathTabId) {
      return pathTabId;
    }
    return state?.tabId;
  }, [pathTabId, state]);
  return { tabId };
};
